<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="first">
          <order-single v-if="activeName == 'first'" :tabCurrent="activeNum"></order-single>
        </el-tab-pane>
        <el-tab-pane :label="'待支付('+countData.needPayNum+')'" name="second">
          <order-single v-if="activeName == 'second'" :tabCurrent="activeNum"></order-single>
        </el-tab-pane>
        <el-tab-pane :label="'待发货('+countData.needSendNum+')'" name="third">
          <order-single v-if="activeName == 'third'" :tabCurrent="activeNum"></order-single>
        </el-tab-pane>
        <el-tab-pane :label="'待核销('+countData.needWriteOffNum+')'" name="fourth">
          <order-single v-if="activeName == 'fourth'" :tabCurrent="activeNum"></order-single>
        </el-tab-pane>
        <el-tab-pane label="待收货" name="fifth">
          <order-single v-if="activeName == 'fifth'" :tabCurrent="activeNum"></order-single>
        </el-tab-pane>
        <!-- <el-tab-pane label="待评价" name="sixth">
          <order-single v-if="activeName == 'sixth'" :tabCurrent="activeNum"></order-single>
        </el-tab-pane> -->
        <el-tab-pane label="已核销" name="seventh">
          <order-single v-if="activeName == 'seventh'" :tabCurrent="activeNum"></order-single>
        </el-tab-pane>
        <el-tab-pane label="已完成" name="eighth">
          <order-single v-if="activeName == 'eighth'" :tabCurrent="activeNum"></order-single>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { queryOrderPageCount } from '@/api/order'
import OrderSingle from './components/OrderSingle.vue'
export default {
  name: 'Order',
  components: {
    OrderSingle
  },
  data () {
    return {
      imgServer: this.$imgServer,
      fullscreenLoading: false,
      activeName: 'first',
      activeNum:99,
      countData:{
        needPayNum:0,
        needSendNum:0,
        needWriteOffNum:0
      }
    }
  },
  mounted () {
    this.countFun();
  },
  methods: {
    /* 切换选项卡操作 */
    handleClick (tab) {
      if(tab.name === 'first'){
        this.activeNum = 99
      }else if(tab.name === 'second'){
        this.activeNum = 0
      }else if(tab.name === 'third'){
        this.activeNum = 1
      }else if(tab.name === 'fourth'){
        this.activeNum = 5
      }else if(tab.name === 'fifth'){
        this.activeNum = 2
      }else if(tab.name === 'sixth'){
        this.activeNum = 4
      }else if(tab.name === 'seventh'){
        this.activeNum = 6
      }else{
        this.activeNum = 3
      }
    },
    /* 统计数量 */
    countFun(){
      var that = this;
      queryOrderPageCount({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.countData = data;
        }
      });
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/Order.vue